module.exports = __webpack_public_path__ + "img/8.8587a2fc.jpg";